import '../jquery'

let ready_mass_sms_template_message;

ready_mass_sms_template_message = function() {
  let massSmsMessageCharCount, isGSM;
  isGSM = function(message) {

    let data, dataLen, gsm, i;
    gsm = ' @£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}[~]|€ÆæßÉ!"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà' + '\n';
    dataLen = message.length;
    i = 0;
    while (i < dataLen) {
      data = message[i];
      if (!gsm.includes(data)) {
        return false;
      }
      ++i;
    }
    return true;
  };
  window.count_message_rest_symb = function(obj) {
    let current_len, gsm, message_length, messages, resp, rest;
    gsm = isGSM($(obj).val());
    if (!gsm) {
      message_length = 70;
    } else {
      message_length = 160;
    }
    current_len = $(obj).val().length;
    messages = Math.ceil(current_len / message_length);
    if (messages > 1 && !gsm) {
      message_length = 67;
      messages = Math.ceil(current_len / message_length);
    } else {
      if (messages > 1) {
        message_length = 153;
      }
      messages = Math.ceil(current_len / message_length);
    }
    if (messages === 0) {
      rest = message_length;
    } else {
      rest = message_length * (messages === 0 ? 1 : messages) - current_len;
    }
    resp = {};
    resp.rest = rest;
    resp.lngth = message_length;
    resp.messages = messages;
    resp.current = current_len;
    return resp;
  };
  massSmsMessageCharCount = function() {
    return $('.mass_sms_message_form').each(function() {
      return massSmsUpdateMessageCharCount($(this));
    });
  };
  window.massSmsUpdateMessageCharCount = function(form) {
    let resp, textarea;
    textarea = $(form).find('textarea.mass_sms_message_field');
    resp = count_message_rest_symb(textarea);
    $(form).find('.message_rest_char_count').text(resp.rest);
    return $(form).find('.messages_count').text(resp.messages);
  };
  $("body").on("keyup", ".mass_sms_message_form", function() {
    return massSmsUpdateMessageCharCount($(this));
  });
  return massSmsMessageCharCount();
};

$(document).ready(ready_mass_sms_template_message);

$(document).on('turbo:load', ready_mass_sms_template_message);